import { v4 as uuidv4 } from 'uuid'

import { END_DATE, START_DATE } from '../../../../../forms/ReusableFormFields/StartEndDateRangeFields/fields'
import { UnitedKingdomRegions } from '../../SroiGraphsOld/ImpactByRegion/maps/UnitedKingdomMap/constants'
import { AustraliaRegionsOptions } from '../../SroiGraphsOld/ImpactByRegion/maps/AustraliaMap/constants'

export const operationsCountriesOptions = [
  {
    value: 'GBR',
    label: 'United Kingdom'
  },
  {
    value: 'AUS',
    label: 'Australia'
  }
]

export const assumptionsOptions = [
  {
    value: 'FinancialImpact',
    label: 'Financial Impact'
  },
  {
    value: 'ViewersHealthImpact',
    label: 'Viewers Health Impact'
  },
  {
    value: 'AttendeesHealthImpact',
    label: 'Attendees Health Impact'
  },
  {
    value: 'ViewersWellbeingImpact',
    label: 'Viewers Wellbeing Impact'
  },
  {
    value: 'AttendeesWellbeingImpact',
    label: 'Attendees Wellbeing Impact'
  },
  {
    value: 'ParticipantsHealthImpact',
    label: 'Participants Health Impact'
  },
  {
    value: 'ParticipantsWellbeingImpact',
    label: 'Participants Wellbeing Impact'
  }
]

export const stakeholderTypeOptions = [
  {
    value: 'Beneficiaries',
    label: 'Beneficiaries'
  },
  {
    value: 'CommunityVolunteers',
    label: 'Community Volunteers'
  },
  {
    value: 'Players',
    label: 'Players'
  },
  {
    value: 'EventVolunteers',
    label: 'Event Volunteers'
  },
  {
    value: 'Attendees',
    label: 'Attendees'
  },
  {
    value: 'Viewers',
    label: 'Viewers'
  }
]

// general inputs
export const COUNTRY_OF_OPERATION = 'countryOfOperation'
export const REPORTING_PERIOD_START = 'reportingPeriodStart'
export const REPORTING_PERIOD_END = 'reportingPeriodEnd'
export const EVENT_INVESTMENT = 'eventInvestment'
export const EVENT_DURATION = 'eventDuration'
export const COMMUNITY_INVESTMENT = 'communityInvestment'
export const COMMUNITY_DURATION = 'communityDuration'

// assumptions section
export const ASSUMPTIONS = 'assumptions'
export const DROP_OFF = 'dropOff'
export const DEAD_WEIGHT = 'deadWeight'
export const ATTRIBUTION = 'attribution'
export const DISPLACEMENT = 'displacement'
export const ASSUMPTION_NAME = 'assumptionName'
// stakeholder details section
export const STAKEHOLDERS_LIST = 'sports'
export const STAKEHOLDER_TYPE = 'stakeholderType'
export const STAKEHOLDER_COUNT = 'stakeholderCount'
export const REGION = 'region'
export const MALE_PERCENTAGE = 'malePercentage'
export const FEMALE_PERCENTAGE = 'femalePercentage'
export const UNKNOWN_GENDER_PERCENTAGE = 'unknownGenderPercentage'
export const WHITE_PERCENTAGE = 'whitePercentage'
export const BAME_PERCENTAGE = 'BAMEPercentage'
export const UNKNOWN_ETHNICITY_PERCENTAGE = 'unknownEthnicityPercentage'
export const LIFE_SATISFACTION_PERCENTAGE = 'lifeSatisfactionPercentage'
export const AVERAGE_LIFE_SATISFACTION_RATING = 'averageLifeSatisfactionRating'
export const PURPOSE_OF_LIFE_PERCENTAGE = 'purposeOfLifePercentage'
export const AVERAGE_PURPOSE_OF_LIFE_RATING = 'averagePurposeOfLifeRating'
export const HAPPINESS_PERCENTAGE = 'happinessPercentage'
export const AVERAGE_HAPPINESS_RATING = 'averageHappinessRating'
export const DECREASED_ANXIETY_PERCENTAGE = 'decreasedAnxietyPercentage'
export const AVERAGE_DECREASED_ANXIETY_RATING = 'averageDecreasedAnxietyRating'
// regions
export const regions = [
  ...UnitedKingdomRegions,
  ...AustraliaRegionsOptions,
  {
    value: 'Unknown',
    label: 'Unknown'
  }
]

export const initialStakeholder = {
  [STAKEHOLDER_TYPE]: '',
  [STAKEHOLDER_COUNT]: 0,
  [REGION]: '',
  [MALE_PERCENTAGE]: 0,
  [FEMALE_PERCENTAGE]: 0,
  [UNKNOWN_GENDER_PERCENTAGE]: 0,
  [WHITE_PERCENTAGE]: 0,
  [BAME_PERCENTAGE]: 0,
  [UNKNOWN_ETHNICITY_PERCENTAGE]: 0,
  [LIFE_SATISFACTION_PERCENTAGE]: 0,
  [AVERAGE_LIFE_SATISFACTION_RATING]: 0,
  [PURPOSE_OF_LIFE_PERCENTAGE]: 0,
  [AVERAGE_PURPOSE_OF_LIFE_RATING]: 0,
  [HAPPINESS_PERCENTAGE]: 0,
  [AVERAGE_HAPPINESS_RATING]: 0,
  [DECREASED_ANXIETY_PERCENTAGE]: 0,
  [AVERAGE_DECREASED_ANXIETY_RATING]: 0
}

export const initialAssumption = {
  [DROP_OFF]: 0,
  [DEAD_WEIGHT]: 0,
  [ATTRIBUTION]: 0,
  [DISPLACEMENT]: 0,
  [ASSUMPTION_NAME]: ''
}

export const getInitialValues = sroiReport => {
  return {
    // general inputs section
    [COUNTRY_OF_OPERATION]: sroiReport?.payload?.[COUNTRY_OF_OPERATION] || '',
    [START_DATE]: sroiReport?.payload?.[REPORTING_PERIOD_START] || new Date(),
    [END_DATE]: sroiReport?.payload?.[REPORTING_PERIOD_END] || new Date(),
    [EVENT_INVESTMENT]: sroiReport?.payload?.[EVENT_INVESTMENT] || '',
    [EVENT_DURATION]: sroiReport?.payload?.[EVENT_DURATION] || '',
    [COMMUNITY_INVESTMENT]: sroiReport?.payload?.[COMMUNITY_INVESTMENT] || '',
    [COMMUNITY_DURATION]: sroiReport?.payload?.[COMMUNITY_DURATION] || '',
    // assumptions section
    [ASSUMPTIONS]:
      sroiReport?.payload?.[ASSUMPTIONS]?.map(assumption => ({
        ...assumption,
        id: uuidv4(),
        data: assumption
      })) || [],
    // stakeholder details section
    [STAKEHOLDERS_LIST]:
      sroiReport?.payload?.[STAKEHOLDERS_LIST].map(stakeholder => ({
        ...stakeholder,
        id: uuidv4(),
        data: stakeholder
      })) || []
  }
}
